import { Injector } from '@angular/core';

import { WidgetsService } from '../services/widgets.service';

import { ChartWidgetTypeCategory, KpiWidgetPrebuiltType, Widget } from './widget-models';
import { prebuilt_widgets } from './widget-prebuilt';

import {
  Bold,
  Essentials,
  Italic,
  Paragraph,
  Undo,
  Heading,
  List,
  Clipboard,
  Alignment,
  Underline,
  Strikethrough,
  Indent,
  Font,
  ListProperties,
  Enter
} from 'ckeditor5';
import { MultiLangField } from 'src/app/shared/customization/multilang-input/multi-language';

export interface PreBuiltWidgets {
  id: any;
  description: string;
  img: string;
  singleInstance?: boolean; // If true, only one instance of this widget can be added to the dashboard
  selected: boolean; // If true and singleInstance is true, the widget cannot be added again
}

// Predefined list of prebuilt widgets to be shown in tab
export const kpiPrebuiltWidgetsList: PreBuiltWidgets[] = [
  {
    id: 'TextWidget',
    description: 'dashboards.widgets.text',
    img: '../../../../assets/images/widgets/text.png',
    singleInstance: false,
    selected: false
  },
  {
    id: 'WidgetKpi',
    description: 'dashboards.widgets.kpi_w',
    img: '../../../../assets/images/widgets/tile.png',
    singleInstance: false,
    selected: false
  },
/*   {
    id: 'RecapKpi',
    description: 'Kpi Riepilogo Macchine',
    img: '../../../../assets/images/widgets/tractor.svg',
    singleInstance: true,
    selected: false
  }, */
  {
    id: 'SignalWidget',
    description: 'dashboards.widgets.signals',
    img: '../../../../assets/images/widgets/signals.png',
    singleInstance: false,
    selected: false
  },
  {
    id: 'PieWidget',
    description: 'dashboards.widgets.pie',
    img: '../../../../assets/images/widgets/pie.png',
    singleInstance: false,
    selected: false
  },
  {
    id: 'GaugeWidget',
    description: 'dashboards.widgets.gauge',
    img: '../../../../assets/images/widgets/gauge.svg',
    singleInstance: false,
    selected: false
  },
  {
    id: 'TermometerWidget',
    description: 'dashboards.widgets.termometer',
    img: '../../../../assets/images/widgets/termometer.svg',
    singleInstance: false,
    selected: false
  },
  {
    id: 'TableWidget',
    description: 'dashboards.widgets.table_w',
    img: '../../../../assets/images/widgets/table.png',
    singleInstance: false,
    selected: false
  },
  {
    id: 'MapWidget',
    description: 'dashboards.widgets.map',
    img: '../../../../assets/images/widgets/map.svg',
    singleInstance: true,
    selected: false
  },
  /*
  {
    id: TableWidgetPrebuiltType.ScadenzeManutenzioni,
    description: 'Widget Scadenze Manutenzioni',
    img: '../../../../assets/images/widgets/table.png',
    singleInstance: true,
    selected: false
  },
  {
    id: WidgetFilterType.DATE,
    description: 'Filtro data',
    img: '../../../../assets/images/widgets/filter.svg',
    singleInstance: true,
    selected: false
  },
  {
    id: WidgetFilterType.SELECT,
    description: 'Filtro selezione',
    img: '../../../../assets/images/widgets/filter.svg',
    singleInstance: true,
    selected: false
  }, */
  {
    id: 'DividerWidget',
    description: 'dashboards.widgets.divider',
    img: '../../../../assets/images/widgets/divider.svg',
    singleInstance: false,
    selected: false
  }
];

export const machinePrebuiltWidgetsList: PreBuiltWidgets[] = [
  {
    id: 'OverviewWidget',
    description: 'dashboards.widgets.machine_info',
    img: '../../../../assets/images/widgets/info.svg',
    singleInstance: true,
    selected: false
  },
  {
    id: 'WidgetKpi',
    description: 'dashboards.widgets.kpi_w',
    img: '../../../../assets/images/widgets/tile.png',
    singleInstance: false,
    selected: false
  },
  /* {
    id: 'MachineAlertKpi',
    description: 'Alerts',
    img: '../../../../assets/images/widgets/alert.svg',
    singleInstance: true,
    selected: false
  }, */
  {
    id: 'SignalWidget',
    description: 'dashboards.widgets.signals',
    img: '../../../../assets/images/widgets/signals.png',
    singleInstance: false,
    selected: false
  },
  {
    id: 'PieWidget',
    description: 'dashboards.widgets.pie',
    img: '../../../../assets/images/widgets/pie.png',
    singleInstance: false,
    selected: false
  },
  {
    id: 'GaugeWidget',
    description: 'dashboards.widgets.gauge',
    img: '../../../../assets/images/widgets/gauge.svg',
    singleInstance: false,
    selected: false
  },
  {
    id: 'TermometerWidget',
    description: 'dashboards.widgets.termometer',
    img: '../../../../assets/images/widgets/termometer.svg',
    singleInstance: false,
    selected: false
  },
  {
    id: 'MapWidget',
    description: 'dashboards.widgets.map',
    img: '../../../../assets/images/widgets/map.svg',
    singleInstance: true,
    selected: false
  },
  {
    id: 'ImageWidget',
    description: 'dashboards.widgets.image',
    img: '../../../../assets/images/widgets/image.png',
    singleInstance: true,
    selected: false
  }
];

// Function to map the prebuilt widget element with its effective configuration
export function getWidgetById(w: PreBuiltWidgets): Widget | undefined {
  const widget = prebuilt_widgets.find((widget) => widget.id === w.id);
  (widget!.config.generic.title as MultiLangField) = {
    fieldTitle: 'title',
    // Chiave i18n: viene tradotta da multilang-input (prima mostrava la description grezza del widget)
    defaultPlaceholder: 'dashboards.widgets.config.titlePlaceholder',
    labels: [
      { lang: 'en', value: '' },
    ]
  };
  widget!.config.generic.showTitle = true;
  const clonedWidget = JSON.parse(JSON.stringify(widget));
  clonedWidget.id = Math.random().toString(36).substring(2, 15);
  return clonedWidget;
}

export class ChartsEvents {
  static getZoomEvent(chart: any): void {
    const injector = Injector.create({
      providers: [{ provide: WidgetsService, deps: [] }]
    });
    const widgetsService = injector.get(WidgetsService);
    return widgetsService.handleZoomEvent(chart);
  }
}

export const signalsChartType = [
  { id: ChartWidgetTypeCategory.LINE, description: 'dashboards.widgets.line' },
  { id: ChartWidgetTypeCategory.BAR, description: 'dashboards.widgets.bar' }
];
export const barTypesChart = [
  //{ id: 'horizontal', description: 'Orizzontale' },
  { id: 'vertical', description: 'dashboards.widgets.vertical_bar' },
  //{ id: 'horizontalStacked', description: 'Orizzontale Stacked' },
  { id: 'verticalStacked', description: 'dashboards.widgets.vertical_stacked_bar' }
];
export const pieTypesChart = [
  { id: 'pie', description: 'dashboards.widgets.pie' },
  { id: 'doughnut', description: 'dashboards.widgets.doghnut' },
  { id: 'polarArea', description: 'dashboards.widgets.polar_area' }
];
export const legendPositionOptions = [
  { id: 'top', description: 'dashboards.widgets.legend_top' },
  { id: 'bottom', description: 'dashboards.widgets.legend_bottom' },
  { id: 'left', description: 'dashboards.widgets.legend_left' },
  { id: 'right', description: 'dashboards.widgets.legend_right' }
];
export const legendOrientOptions = [
  { id: 'horizontal', description: 'dashboards.widgets.legend_horizontal' },
  { id: 'vertical', description: 'dashboards.widgets.legend_vertical' }
];

export const kpiVerticalIconsList = [];
export const iconsCatalog = [
  // --- Dashboard / Analisi / Statistiche / Monitoraggio ---
  "analytics", "insights", "monitoring", "query_stats", "leaderboard",
  "bar_chart", "pie_chart", "show_chart", "stacked_bar_chart",
  "trending_up", "trending_down", "data_usage", "timeline",
  "space_dashboard", "widgets", "table_chart", "graphic_eq",
  "assessment", "equalizer", "multiline_chart", "legend_toggle",
  "track_changes", "scoreboard", "troubleshoot", "bubble_chart",
  "inventory", "inventory_2", "dataset", "dataset_linked",
  "query_builder", "view_quilt", "view_module",
  "compare_arrows", "cloud_sync", "data_exploration",
  "sensors", "sensors_alt", "pivot_table_chart", "data_object",
  "schema", "precision_manufacturing", "calculate",
  "health_and_safety", "system_security_update_good",
  "running_with_errors", "rule", "rule_folder", "network_check",
  "lan", "rss_feed", "settings_applications", "manage_history",
  "build_circle", "adjust", "toggle_on", "toggle_off",
  "view_sidebar", "view_comfy_alt", "view_compact_alt",
  "view_stream", "dashboard_customize", "window",
  "chrome_reader_mode", "report_problem",
  "error_outline", "info_outline", "check_circle_outline",
  "pending_actions", "hourglass_top", "hourglass_bottom",
  "task_alt", "group_work", "account_balance_wallet",
  "verified_user", "support_agent", "person_search",
  "contact_page", "app_registration", "category",
  "donut_large", "donut_small", "heat_pump", "line_axis",
  "shape_line", "stacked_line_chart", "area_chart",
  "agriculture",

  // --- Orari / Tempo / Allarmi / Timer ---
  "schedule", "access_time", "timer", "alarm", "alarm_on", "alarm_pause",
  "alarm_off", "alarm_add", "alarm_remove", "alarm_snooze",
  "hourglass_empty", "hourglass_full", "watch_later", "watch", "watch_off",

  // --- Consumi / Energia / Misurazioni ---
  "bolt", "battery_full", "battery_charging_full", "battery_alert",
  "battery_saver", "flash_on", "flash_off", "light_mode", "dark_mode",
  "power", "power_settings_new", "electric_bolt", "electric_meter",
  "energy_savings_leaf", "gas_meter", "oil_barrel", "local_gas_station",
  "speed", "mode_standby", "device_thermostat",

  // --- Auto / Trasporti / Automotive / GPS / Navigazione ---
  "directions_car", "local_taxi", "electric_car", "commute",
  "directions_bus", "directions_railway", "train", "tram",
  "flight", "airport_shuttle", "local_shipping", "directions_boat",
  "two_wheeler", "pedal_bike", "local_car_wash", "car_rental",
  "car_repair", "directions_car_filled", "ev_station", "ev_station_filled",
  "gps_fixed", "gps_not_fixed", "gps_off", "location_on", "location_searching",
  "map", "navigation", "pin_drop", "satellite", "traffic", "trip_origin",
  "turn_left", "turn_right", "turn_sharp_left", "turn_sharp_right",
  "turn_slight_left", "turn_slight_right", "directions", "directions_walk",
  "directions_bike", "directions_transit", "directions_subway",
  "directions_train", "directions_car_filled", "directions_bus_filled",
  "directions_railway_filled", "directions_boat_filled", "directions_air_filled",
  "electric_car_filled", "car_repair_filled",

  // --- Resto (lista comune) ---
  "home", "menu", "search", "close", "check", "add", "edit", "delete",
  "arrow_back", "arrow_forward", "arrow_upward", "arrow_downward",
  "account_circle", "person", "people", "settings", "info", "help",
  "logout", "login", "lock", "lock_open", "visibility", "visibility_off",
  "star", "star_border", "favorite", "favorite_border",
  "notifications", "notifications_none", "notifications_active",
  "shopping_cart", "shopping_bag", "credit_card", "payment",
  "event", "calendar_today", "today",
  "dashboard", "list", "view_list", "grid_view", "apps",
  "cloud", "cloud_download", "cloud_upload", "cloud_done",
  "download", "upload", "save", "print", "share",
  "email", "mail", "send", "chat", "message", "forum",
  "phone", "call", "smartphone", "computer", "laptop",
  "folder", "folder_open", "attach_file", "insert_drive_file",
  "camera_alt", "photo", "image", "collections",
  "play_arrow", "pause", "stop", "skip_next", "skip_previous",
  "volume_up", "volume_off", "mic", "mic_off",
  "location_on", "map", "place", "pin_drop", "navigation",
  "build", "construction", "engineering", "handyman",
  "warning", "error", "check_circle", "highlight_off",
  "done", "done_all", "pending", "refresh", "autorenew", "sync", "update",
  "zoom_in", "zoom_out", "fullscreen", "fullscreen_exit",
  "arrow_drop_down", "arrow_drop_up", "expand_more", "expand_less",
  "chevron_left", "chevron_right", "first_page", "last_page",
  "thumb_up", "thumb_down", "open_in_new", "launch",
  "link", "attachment", "content_copy", "content_paste",
  "crop", "filter_list", "sort", "tune",
  "account_balance", "work", "business", "domain",
  "wifi", "signal_cellular_4_bar", "bluetooth", "airplanemode_active",
  "location_searching", "school", "language", "translate", "public",
  "sports_soccer", "sports_basketball", "fitness_center", "directions_run",
  "emoji_emotions", "emoji_people", "emoji_events", "emoji_food_beverage",
  "medical_services", "healing", "local_hospital", "vaccines",
  "restaurant", "local_cafe", "local_bar", "local_grocery_store",
  "hotel", "security", "shield", "policy", "verified",
  "assignment", "note", "description", "article", "library_books",
  "code", "terminal", "bug_report", "integration_instructions",
  "design_services", "architecture", "science",
  "group", "group_add", "manage_accounts", "supervisor_account",
  "account_box", "account_tree", "admin_panel_settings"
];
export const kpiPrebuilted = [
  { id: KpiWidgetPrebuiltType.VEHICLES_RECAP, description: 'Riepilogo Macchine'}
]

export const textEditorConfig = {
  fontSize: {
    options: [9, 10, 11, 12, 14, 16, 18, 20]
  },
  toolbar: {
    items: [
      'undo',
      'redo',
      '|',
      'heading',
      'fontSize',
      'fontFamily',
      'fontColor',
      'fontBackgroundColor',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      '|',
      'alignment',
      'indent',
      'outdent',
      '|',
      'bulletedList',
      'numberedList'
    ],
    shouldNotGroupWhenFull: true
  },
  plugins: [
    Font,
    Bold,
    Essentials,
    Italic,
    Paragraph,
    Undo,
    Heading,
    List,
    ListProperties,
    Clipboard,
    Alignment,
    Underline,
    Strikethrough,
    Indent,
    Enter
  ],
  list: {
    properties: {
      styles: true,
      startIndex: true,
      reversed: true
    }
  },
  licenseKey: '<YOUR_LICENSE_KEY>',
  initialData: ''
};
